<template>
  <div class="goshonging">
    <!-- 黑色顶部区域 -->
    <div class="puk-top-section">
        <div class="puk-header">
            <!-- <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxsaW5lIHgxPSIxOCIgeTE9IjEyIiB4Mj0iNSIgeTI9IjEyIj48L2xpbmU+PHBvbHlsaW5lIHBvaW50cz0iMTIgMTkgNSAxMiAxMiA1Ij48L3BvbHlsaW5lPjwvc3ZnPg==" 
                class="puk-back" > -->
                <van-icon class="puk-back" name="arrow-left" size="30px" @click="goBack"/>  
            <img :src="imgtitle" class="puk-logo" alt="PUKI">
        </div>
    </div>

     <!-- 白色主体区域 -->
        <div class="puk-main-section">


                   <!-- 商品图片_分页 -->
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(img, index) in  product.images" :key="index">
                        <div class="puk-product-image">
                            <img :src="img" :alt="'商品图片' + (index + 1)">
                        </div>
                    </div>
                </div>
                <!-- 添加分页器 -->
                <div class="swiper-pagination"></div>
                </div>
                     <!-- 颜色选择区：点击颜色时控制轮播切换 -->
                    <div class="puk-color-options">
                        <div v-for="(color, index) in product.colors" 
                            :key="index"
                            class="puk-color-item"
                            @click="selectColor(index)">
                        <div class="puk-color-option"
                            :class="{ active: currentColorIndex === index }"
                            :style="{ backgroundColor: color.code }">
                        </div>
                        <span v-if="currentColorIndex === index" class="puk-color-name">{{ color.name }}</span>
                        </div>
                    </div>
                     <!-- 商品信息 -->
            <div class="puk-product-info">
                <div class="puk-product-model">{{ product.model }}</div>
                <div class="puk-product-spec">{{ product.size }}</div>
                <div class="puk-product-material">{{ product.material }}</div>
                <div  class="puk-product-custom">{{product.contentxt}}</div>
                <div v-if=" product.price!=0" class="puk-product-price">${{ product.price }}</div>
            </div>
            
            <!-- 商品詳情頁面 -->
            <div class="imagesite-container">
                <img v-for="(img, index) in product.imagesdetail" :key="index" :src="img"  class="image" />
              </div>
          

          
        <!-- 购买按钮 -->
            <button class="puk-buy-button" @click="showContactPopup = true">
              Contact to buy
            </button>
          
                 <!-- 客服联系窗口 -->
                    <van-popup v-model="showContactPopup" position="bottom" :style="{ height: '80vh',borderRadius: '20px' }">
                        <!-- 弹窗内容 -->
                        <div class="puk-contact-popup" style=" overflow-y: scroll;">
                            <div class="box box1">
                                <img style=" margin-top: 20px; width:60px;height:40px;margin-left:4vw" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTEyIDVsLTQgNCA0IDQiLz48L3N2Zz4=" alt="图标" @click="goshowContactPopup">

                                <div class="puk-back-text">
                                    <h3 style="font-size: 1rem;">Contact customer service</h3>
                                    <p style="font-size: 0.8rem;margin-top: -0.7rem; white-space: nowrap;">You can choose any of the following methods</p>
                                </div>
                            </div>
                            <div class="box box2">
                                <div class="puki-contact">
                                <div class="puk-back-phone">phone：86/20/39390239</div>
                                <div class="puk-back-email">email：coop@puki.vip</div>
                                </div>
                            </div>
                            <div class="box box3">
                                <div class="fomebox3">
                                          <!-- 用户表单提交 -->
                            <div class="custom-title">Message</div>  
                                <form class="custom-form" @submit.prevent="submitForm">
                                    <!-- 姓名 -->
                                    <div class="form-group">
                                        <label for="pukiname"> name</label>
                                        <input type="text" id="pukiname" v-model="formData.pukiname" placeholder="Please enter your name">
                                    </div>
                                    <!-- 联系电话 -->
                                    <div class="form-group">
                                        <label for="pukiphone"> phone</label>
                                        <input type="text" id="pukiphone" v-model="formData.pukiphone" placeholder="Please enter your phone">
                                    </div>
                                     <!-- 电子邮箱 -->
                                     <div class="form-group">
                                        <label for="pukiemail"> email</label>
                                        <input type="text" id="pukiemail" v-model="formData.pukiemail" placeholder="Please enter your email">
                                    </div>
                                     <!-- 联系地址 -->
                                     <div class="form-group">
                                        <label for="pukiaddress"> address</label>
                                        <input type="text" id="pukiaddress" v-model="formData.pukiaddress"  placeholder="Please enter your address">
                                    </div>
                                    <!-- 预购产品 -->
                                    <div class="form-group" style="padding: 15px 8px;">
                                        <label for="pukiwangtgoshopping">desired product</label>
                                        <input type="text" id="wangtshopping" v-model="formData.wangtshopping" placeholder="Please enter your message">
                                    </div>

                                    <p style="font-size: 10px; margin-left:20px;margin-top:8px">(*After submitting the message, a PUKI customer service representative will contact you)</p>

                                            <!-- 提交按钮 -->
                                    <button type="submit" class="pukisubmit-btn" >submit</button>

                                  
                                </form>
                        

                        </div>
                    </div>

                            <div class="box box4" style="margin-top:8px" >
                              <a href="https://work.weixin.qq.com/kfid/kfc21a3e1886e908fbc" target="_blank">
                                         <!-- 添加客服 -->
                             <button type="submit"  class="pukiuser-btn">Online customer service</button>
                             </a>
                            </div>
                        
                        </div>
                    </van-popup>

        </div>
       
  <div style="height: 20vh;width:100vw; background-color: white;"></div>
  
      
        <div style="width: 100vw;">
            <bottomh5></bottomh5>
          </div>


         
     
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import Swiper, { Pagination, Autoplay, Navigation } from 'swiper'; // 导入 Swiper 和相关模块
import 'swiper/css/swiper.min.css' // 注意这里的引入
import bottomh5 from'@/view/h5/public/bottomh5en.vue'
 import axios from 'axios';
 import apiUrls from '@/http/http';
 import CryptoJS from "crypto-js";
export default {
  name: 'goshopping',
  components:{
          bottomh5
        },
  data() {
    return {
      formData: {
                pukiname: "",
                pukiphone: "",
                pukiemail: "",
                pukiaddress: "",
                wangtshopping: "",
            },
        imgtitle: require('@/assets/logoh5new.png'), // 使用 require 引入图片
      // 在这里定义组件的数据
      imagesdetail: [
            require('@/assets/detail35.png'), 
            require('@/assets/detail36.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail38.png'), 
            require('@/assets/detail39.png'), 
            require('@/assets/detail40.png'), 
            require('@/assets/detail41.png'), 
            require('@/assets/detail42.png'), 
            require('@/assets/detail43.png'), 
            require('@/assets/detail44.png'), 
            require('@/assets/detail45.png'), 
            require('@/assets/detail46.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail48.png'), 
            require('@/assets/detail49.png'), 
            require('@/assets/detail50.png'), 
            require('@/assets/detail51.png'), 
            require('@/assets/detail52.png'), 
            require('@/assets/detail53.png'), 
            require('@/assets/detail54.png'), 
            require('@/assets/detail55.png'), 
            require('@/assets/detail56.png'), 
            ], // 商品图片数组
            colors: [
                { name: '经典黑', code: '#000000' },
                { name: '珍珠白', code: '#FFFFFF' },
                { name: '天际蓝', code: '#007AFF' },
                { name: '森林绿', code: '#34C759' },
                { name: '魅力紫', code: '#AF52DE' },
                { name: '中国红', code: '#FF3B30' }
            ],
            
          
            currentColorIndex: 0, // 当前轮播图索引
            swiper: null, // 存储 Swiper 实例

            showContactPopup: false,//弹窗控制器

    product: {
        model: "",
        size: "",
        material: "",
        contentxt: "",
        price: "",
        images: [],
        colors: [],
        imagesdetail: [
         
            ],
      },
      productsData: {
        '20寸铝镁合金商旅箱': {
          model: "型号:P0120",
          size: "尺寸:20英寸",
          material: "材质:铝镁合金",
          contentxt:"颜色可定制",
          price: "售价:3599元",
          images: [
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0120pic-24_20241023160814A005.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0120pic-30_20241023160818A006.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0120pic-32_20241023160823A007.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0120pic-31_20241023160830A008.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0120pic-33_20241023160837A009.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0120pic-34_20241023160840A010.jpg`,
          ],
          colors: [
            { name: "经典黑", code: "#000000" },
            { name: "珍珠白", code: "#FFFFFF" },
            { name: "星耀蓝", code: "#0786c7" },
            { name: "松墨绿", code: "#32586B" },
            { name: "晶钻紫", code: "#796886" },
            { name: "宝石红", code: "#E5002B" },
          ],
          imagesdetail: [
            require('@/assets/detail35.png'), 
            require('@/assets/detail36.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail38.png'), 
            require('@/assets/detail39.png'), 
            require('@/assets/detail40.png'), 
            require('@/assets/detail41.png'), 
            require('@/assets/detail42.png'), 
            require('@/assets/detail43.png'), 
            require('@/assets/detail44.png'), 
            require('@/assets/detail45.png'), 
            require('@/assets/detail46.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail48.png'), 
            require('@/assets/detail49.png'), 
            require('@/assets/detail50.png'), 
            require('@/assets/detail51.png'), 
            require('@/assets/detail52.png'), 
            require('@/assets/detail53.png'), 
            require('@/assets/detail54.png'), 
            require('@/assets/detail55.png'), 
            require('@/assets/detail56.png'), 
            ],
        },
        '18寸铝镁合金商旅箱': {
          model: "型号:P0120",
          size: "尺寸:18英寸",
          material: "材质:铝镁合金",
          contentxt:"颜色可定制",
          price: "售价:3499元",
          images: [
            `${apiUrls.devApi}/profile/upload/2024/10/22/p0118pic-23_20241022173127A002.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0118pic-25_20241023160049A003.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0118pic-27_20241023160054A004.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0118pic-26_20241023160102A005.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0118pic-28_20241023160326A002.jpg`,
            `${apiUrls.devApi}/profile/upload/2024/10/23/p0118pic-29_20241023160456A004.jpg`,
          ],
          colors: [
            { name: "经典黑", code: "#000000" },
            { name: "珍珠白", code: "#FFFFFF" },
            { name: "星耀蓝", code: "#0786c7" },
            { name: "松墨绿", code: "#32586B" },
            { name: "晶钻紫", code: "#796886" },
            { name: "宝石红", code: "#E5002B" },
          ],
          imagesdetail: [
            require('@/assets/detail35.png'), 
            require('@/assets/detail36.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail38.png'), 
            require('@/assets/detail39.png'), 
            require('@/assets/detail40.png'), 
            require('@/assets/detail41.png'), 
            require('@/assets/detail42.png'), 
            require('@/assets/detail43.png'), 
            require('@/assets/detail44.png'), 
            require('@/assets/detail45.png'), 
            require('@/assets/detail46.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail48.png'), 
            require('@/assets/detail49.png'), 
            require('@/assets/detail50.png'), 
            require('@/assets/detail51.png'), 
            require('@/assets/detail52.png'), 
            require('@/assets/detail53.png'), 
            require('@/assets/detail54.png'), 
            require('@/assets/detail55.png'), 
            require('@/assets/detail56.png'), 
            ],
        },
        '20寸PC商旅箱': {
          model: "型号: U0120",
          size: "尺寸: 20英寸",
          material: "材质: PC",
          contentxt:"颜色可定制",
          price: "售价: 1199元",
          images: [
            `${apiUrls.devApi}/profile/upload/2024/10/25/pic-U01-35_20241025091605A009.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/pic-U01-37_20241025091645A010.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/pic-U01-38_20241025091728A011.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/pic-U01-39_20241025091811A012.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/pic-U01-40_20241025091836A013.png`,
          ],
          colors: [
            { name: "哑黑", code: "#232428" },
            { name: "哑白", code: "#E7E7E7" },
            { name: "亮灰", code: "#858585" },
            { name: "哑蓝", code: "#202643" },
            { name: "哑绿", code: "#1D2E25" },
          ],
          imagesdetail: [
            require('@/assets/Udeitisimg.jpg'), 
           
            ],
        },
        'K02通勤背包': {
          model: "型号: K0201",
          size: "尺寸: 42*29*19cm",
          material: "材质: 尼龙",
          contentxt:"颜色可定制",
          price: "售价: 399元",
          images: [
            `${apiUrls.devApi}/profile/upload/2024/10/24/pic-K02_20241024172329A003.png`,
            
          ],
          colors: [
            { name: "黑色", code: "#232428" },
          
          ],
          imagesdetail: [
            require('@/assets/detiesk02one.jpg'), 
            require('@/assets/detiesk02tiesktwo.jpg'), 
            ],
        },
        'K03通勤公文包': {
          model: "型号: K0301",
          size: "尺寸: 42*29*19cm",
          material: "材质: 尼龙",
          contentxt:"颜色可定制",
          price: "售价: 399元",
          images: [
            `${apiUrls.devApi}/profile/upload/2024/10/24/pic-K03_20241024173206A006.png`,
            
          ],
          colors: [
            { name: "黑色", code: "#232428" },
          
          ],
          imagesdetail: [
            require('@/assets/detail35.png'), 
            require('@/assets/detail36.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail38.png'), 
            require('@/assets/detail39.png'), 
            require('@/assets/detail40.png'), 
            require('@/assets/detail41.png'), 
            require('@/assets/detail42.png'), 
            require('@/assets/detail43.png'), 
            require('@/assets/detail44.png'), 
            require('@/assets/detail45.png'), 
            require('@/assets/detail46.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail48.png'), 
            require('@/assets/detail49.png'), 
            require('@/assets/detail50.png'), 
            require('@/assets/detail51.png'), 
            require('@/assets/detail52.png'), 
            require('@/assets/detail53.png'), 
            require('@/assets/detail54.png'), 
            require('@/assets/detail55.png'), 
            require('@/assets/detail56.png'), 
            ],
        },
        'E01 PC行李箱': {
          model: "型号: E0120",
          size: "尺寸可选: 20/22/24/26/28英寸",
          material: "材质: PC箱体，铝中框",
          contentxt:"",
          price: "售价: 639元",
          images: [
            `${apiUrls.devApi}/profile/upload/2024/10/25/1pic-E01product-black_20241025094943A020.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/2pic-E01product-green_20241025102920A021.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/3pic-E01product-red_20241025102920A025.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/4pic-E01product-grey_20241025102944A026.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/5pic-E01product-purple_20241025102949A027.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/6pic-E01product-beige_20241025102954A028.png`,
          ],
          colors: [
            { name: "黑色", code: "#000000" },
            { name: "绿色", code: "#5EA277" },
            { name: "酒红色", code: "#c76060" },
            { name: "灰色", code: "#869595" },
            { name: "紫色", code: "#bb55a4" },
            { name: "米黄色", code: "#e9e9e1" },
          ],
          imagesdetail: [
            require('@/assets/detail35.png'), 
            require('@/assets/detail36.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail38.png'), 
            require('@/assets/detail39.png'), 
            require('@/assets/detail40.png'), 
            require('@/assets/detail41.png'), 
            require('@/assets/detail42.png'), 
            require('@/assets/detail43.png'), 
            require('@/assets/detail44.png'), 
            require('@/assets/detail45.png'), 
            require('@/assets/detail46.png'), 
            require('@/assets/detail37.png'), 
            require('@/assets/detail48.png'), 
            require('@/assets/detail49.png'), 
            require('@/assets/detail50.png'), 
            require('@/assets/detail51.png'), 
            require('@/assets/detail52.png'), 
            require('@/assets/detail53.png'), 
            require('@/assets/detail54.png'), 
            require('@/assets/detail55.png'), 
            require('@/assets/detail56.png'), 
            ],
        },
        'E02 PC行李箱': {
          model: "型号: E0220",
          size: "尺寸可选: 20/24/28英寸",
          material: "材质: 铝镁合金",
          contentxt:"",
          price: "售价: 359元",
          images: [
            `${apiUrls.devApi}/profile/upload/2024/10/25/pic-E02product-blacke_20241025103415A030.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/pic-E02product-deepblue_20241025103415A031.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/pic-E02product-grey_20241025103415A029.png`,
          ],
          colors: [
            { name: "黑色", code: "#000000" },
            { name: "蓝色", code: "#083191" },
            { name: "灰色", code: "#878787" },
          ],
          imagesdetail: [
            require('@/assets/Udeitisimg.jpg'), 
           
            ],
        },
        'E03 PC行李箱': {
          model: "型号: E0320",
          size: "尺寸: 20英寸",
          material: "材质: 铝镁合金",
          contentxt:"",
          price: "售价: 939元",
          images: [
            `${apiUrls.devApi}/profile/upload/2024/10/25/E03pic-55_20241025104744A032.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/E03pic-48_20241025104744A033.png`,
            
          ],
          colors: [
            { name: "黑色", code: "#000000" },
           
            { name: "银色", code: "#CECAD2" },
          ],
          imagesdetail: [
           
           
            ],
        },
        'C01 铝镁合金化妆箱': {
          model: "型号: C01",
          size: "尺寸: 6*20*11cm",
          material: "材质: 铝镁合金",
          contentxt:"*可联系客服定制",
          price: "",
          images: [
            `${apiUrls.devApi}/profile/upload/2024/10/25/C-pic-59_20241025110953A035.png`,
            `${apiUrls.devApi}/profile/upload/2024/10/25/C-pic-60_20241025110953A036.png`,
          ],
          colors: [
            { name: "黑色", code: "#000000" },
           
            { name: "银色", code: "#CECAD2" },
          ],
          imagesdetail: [
           
           
            ],
        },
    },
    };
  },
  methods: {
    goshowContactPopup(){
      this.showContactPopup = false;
    },
 goBack() {
      window.history.back(); // 让浏览器返回上一页
    },
    async submitForm() {
            if (!this.formData.pukiname || !this.formData.pukiphone || !this.formData.pukiemail) {
              Toast.fail("请填写完整信息");
              return;
               
            }

            try {
                const response = await axios.post(`${apiUrls.baseUrl}/website/wantshoppingform`, this.formData);
               // 提示成功信息
                Dialog.alert({
                  title: "提交成功",
                  message: response.data || "您的信息已提交成功！",
                });
                 // 清空输入框数据
                  this.formData = {
                          pukiname: "",
                          pukiphone: "",
                          pukiemail: "",
                          pukiaddress: "",
                          wangtshopping: "",
                  };
                
            } catch (error) {
                      Dialog.alert({
                  title: "提交失败",
                  message: error.response?.data || "提交失败，请稍后再试",
                });
            }
        },


    selectColor(index) {
      this.currentColorIndex = index;
      console.log("当前选中的幻灯片索引：", index);
      // 如果已经初始化了 Swiper，则切换到对应的幻灯片
      if (this.swiper) {
        this.swiper.slideTo(index);
      }
    },
    // 在这里定义组件的方法

                    initSwiper() {
                    this.swiper = new Swiper('.swiper-container', {
                        // 基础配置
                        initialSlide: this.currentColorIndex,
                          observeParents: true, // 监听父元素变化 
                          observe: true,        // 监听自身变化 
                        speed: 300,
                        
                        // 分页器
                        pagination: {
                        el: '.swiper-pagination',
                        type: 'fraction', // 设置分页器类型为 'bullets'
                        },
                        
                        // 监听滑动
                        on: {
                        slideChange: () => {
                            this.currentImageIndex = this.swiper.activeIndex;
                            this.currentColorIndex = this.swiper.activeIndex;
                        }
                        }
                    });
                    },

       loadProductData() {
      const productName = this.$route.params.productsname;
       //console.log(productName)
      if (this.productsData[productName]) {
        this.product = this.productsData[productName];
      } else {
        this.product = this.productsData['20寸铝镁合金商旅箱'];
      }
    },

    async decryptAES(mixedData) {
    try {
        // console.log("🔹 混淆数据:", mixedData);

        // 提取密钥和真实的加密数据
        const insertIndex = 10; // 后端在第 10 个字符后插入密钥
        const encryptedData = mixedData.substring(0, insertIndex) + mixedData.substring(insertIndex + 24); // 24 是 Base64 编码的 AES 密钥长度
        const keyBase64 = mixedData.substring(insertIndex, insertIndex + 24);

        // console.log("🔹 提取出的密钥 (Base64):", keyBase64);
        // console.log("🔹 真实加密数据:", encryptedData);

        // 解析 Base64
        const key = CryptoJS.enc.Base64.parse(keyBase64);
        const cipherText = CryptoJS.enc.Base64.parse(encryptedData);

        // AES-ECB 解密
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: cipherText },
            key,
            { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        );

        if (!decrypted || decrypted.sigBytes <= 0) throw new Error("解密失败，可能密钥错误");

        // 转换为 UTF-8 字符串
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        // console.log("🔹 解密后的文本:", decryptedText);

        if (!decryptedText) throw new Error("解密失败，数据无效");

        // 用正则去掉前面的时间戳及冒号，例如 "1742969450878:" 部分
        const jsonPart = decryptedText.replace(/^\d+:/, "");
        // console.log("🔹 去除前缀后的 JSON 数据:", jsonPart);

       // 将 JSON 字符串转换为对象，并返回
       return JSON.parse(jsonPart);
    } catch (error) {
        console.error("❌ 解密失败:", error.message);
        return null;
    }
},

      async produtbyke(){
        try {
          const productName = this.$route.query.productsname;
          // console.log("🔹 接受的参数:", productName);
                const requestBody = {
                  productsname: productName // Replace with the actual product number
                };

                const response = await axios.post(`${apiUrls.baseUrl}/website/goshoppingbyproductnumber`, requestBody, {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                 
                  const result = await this.decryptAES(response.data.mixedData); 
                          if(result) {
                              // console.log(result[0]);  // 访问数组第一个元素
                              // 更新数据
                              this.updateData(result[0]);
                               // 在数据更新后的 nextTick 中操作 DOM 
                                this.$nextTick(() => {
                                    if (this.swiper)  {
                                        this.swiper.destroy(true,  true);
                                    }
                                    this.initSwiper();  // 确保数据渲染完再初始化 
                                  });
                          }else{
                            this.$message.error('获取数据失败');
                          }

                
                } catch (error) {
                      console.error('Error:',  error);
                  }

                },

                updateData(data) {
                  try {

                    // 假设 data 就是需要赋值给 product 的对象
                    // console.log(data.color);
                    // console.log(data.colordescription);
                     this.product = {
                                  model: data.modelnumberen || "",              // 例如："型号：P0120"
                                  size: data.productsizeen || "",               // 例如："尺寸:20寸"
                                  material: data.productmaterialen || "",       // 例如："材质：铝镁合金"
                                  contentxt: data.productcustomizationen || "",       // 例如："材质：铝镁合金"
                                  price: data.productpriceen || "",             // 例如：3599
                                  images: data.productcarouseimage ? this.addPrefixToImageUrls(data.productcarouseimage, apiUrls.devApi) : [], // 用逗号分割成数组
                                  colors: data.color ? this.transformColors(data.color, data.colordescriptionen) : [],                          // 用逗号分割颜色
                                  imagesdetail: data.productdetailsimage ? this.addPrefixToImageUrls(data.productdetailsimage, apiUrls.devApi) : []
                                };
                    //  console.log("更新后的产品数据:", this.product);
                    }catch (error) {
                      // console.error("更新产品数据时发生错误:", error);
                     // 使用 Vant 的 Dialog 弹窗显示错误信息
                        Dialog.alert({
                          title: '错误',
                          message: '未找到该产品详情'
                        }).then(() => {
                          // 处理弹窗关闭后的操作（如：重置数据或其他逻辑）
                          this.$router.push({ name: 'productrange'});
                        });

                        // 使用 Toast 提示用户
                        Toast.fail('产品详情加载失败');
                    }
                },
                  /**
                   * 将图片路径字符串转换为数组，并为每个路径添加前缀
                   * @param {string} imageStr - 原始图片路径字符串，多个路径用逗号分隔
                   * @param {string} prefix - 要添加的前缀，比如 apiUrls.devApi
                   * @returns {Array} - 添加前缀后的图片路径数组
                   */
                   addPrefixToImageUrls(imageStr, prefix) {
                    // 使用逗号分割生成数组
                    const imagesArray = imageStr.split(",");
                    // 为每个路径添加前缀
                    const imagesWithPrefix = imagesArray.map(url => `${prefix}${url}`);
                    return imagesWithPrefix;
                  },


                  /**
                 * 将产品数据中的 color 和 colordescription 转换为颜色对象数组
                 * @param {string} colorStr - 颜色代码字符串，例如 "black,white,blue,green,purple,brown"
                 * @param {string} colordescriptionStr - 颜色描述字符串，例如 "经典黑,珍珠白,星耀蓝,松墨绿,晶钻紫,宝石红"
                 * @returns {Array} 颜色对象数组，每个对象包含 { code, name }
                 */
                 transformColors(colorStr, colordescriptionStr) {
                  // 按逗号分割字符串
                  const codes = colorStr.split(",");
                  const names = colordescriptionStr.split(",");
                  
                  // 如果两个数组长度不匹配，可根据实际情况处理，这里假设长度一致
                  const result = codes.map((code, index) => {
                    return {
                      code: code.trim(),
                      name: names[index] ? names[index].trim() : ""
                    };
                  });
                  
                  return result;
                }


        },

  computed: {
  productsname() {
    return this.$route.query.productsname;
  }
  
},
watch: {
  
},
beforeDestroy() {
    if (this.swiper)  {
        this.swiper.destroy(true,  true); // 避免内存泄漏 
    }
},
  mounted() {
    this.produtbyke();
    // 在这里添加任何需要执行的挂载逻辑
      //  this.$nextTick(() => {
      //           this.initSwiper();
      //       });
      // this.initSwiper();
  },
  created() {
    
    // this.loadProductData();
  },
};
</script>

<style scoped>
/deep/.el-menu{
    padding-left: 3.5vw;
  }
.goshonging {
  /* 在这里添加组件的样式 */
  height: auto;
}
/* 顶部黑色部分 */
.puk-top-section {
    background: #1a1a1a;
    width: 100%;
    height: 50px;
    padding-top: 20px;
}

.puk-header {
    display: flex;
    align-items: center;
    padding: 16px;
    background: #1a1a1a;
    color: white;
    height: 30px;
    justify-content: center;
    max-width: 414px;
    margin: 0 auto;
    position: relative;
}

.puk-back {
  position: absolute;
  left: 16px;
  top: -1px;
}

.puk-logo {
    height: 20px;
    width: auto;
    display: block;
    position: relative;
    top:-1vh;
    transform: translateY(-50%);
    
}

/* 白色主体部分 */
.puk-main-section {
    background: white;
    border-radius: 20px 20px 0 0;
    position: relative;
    z-index: 1;
    padding-top: 30px;

    height: auto;
    margin-top: -1vh;
    overflow-y: scroll;
    
}
/* 数字分页器的样式 */
.swiper-pagination-fraction {
    width: 60px; /* 设置分页器的宽度 */
    height: 30px; /* 设置分页器的高度 */
    line-height: 30px; /* 使文字垂直居中 */
    text-align: center; /* 使文字水平居中 */
    font-size: 16px; /* 设置文字大小 */
    color: #000; /* 设置文字颜色 */
    background: #fff; /* 设置分页器的背景颜色 */
    border-radius: 15px; /* 设置分页器的圆角 */
    position: absolute;
    bottom: 10px; /* 调整分页器的位置 */
    left: 90%;
    transform: translateX(-50%);
}      


.puk-product-image{
    width: 100vw;
    height: 400px;
    display: flex;
    justify-content: center;
}
.puk-product-image img{
    width: 100%;
    height: 100%;
}
/* 颜色选择区 */
.puk-color-options {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    padding: 20px 0;
}

.puk-color-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 5px;
}

.puk-color-option {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid transparent;
    cursor: pointer;
    transition: transform 0.2s ease, border-color 0.2s ease;
    margin-bottom: 4px;
    border-color: #909192;
}

.puk-color-option.active {
    border-color: #909192;
   box-shadow: 0 0 0 0.3rem white, 0 0 0 0.4rem #555555;
}

.puk-color-name {
    font-size: 0.5rem;
    color: #666;
    margin-top: 4px;
}

/* 尺码选择区 */
/* 商品信息区 */
.puk-product-info {
    padding: 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    font-weight: 300;
    
    color: #848383;/*灰色？*/
    line-height: 4vh;
}



.puk-buy-button {
   
    position: fixed;
    bottom: 10vh;
    left: 50%;
    transform: translateX(-50%);
    max-width: 382px;
    width: calc(100% - 250px);
    background: #000;
    color: white;
    border: none;
    border-radius: 10px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
}



/* 弹窗 */
.puk-contact-popup{
    display: flex;
    flex-direction: column;
    height: 70vh;
    gap: 15px;
    background-color: #FFFFFF;
}
  
  .box1 {
    
   
    display: flex;
    gap: 6vw;
  }
  
  .box2 {
    display: flex;
    justify-content: center;
  }
  
  .box3 {
    display: flex;
    justify-content: center;
    background-color: #FFFFFF;
   
  }
  
  .box4 {
   
   
    display: flex;
    justify-content: center;
  }

  .puk-back-text{
   
    width: 50vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    
  }

  .puki-contact{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 5vw;
    width: 80vw;
    background-color: #f7f7f7;
    /* 添加圆角 */
  border-radius: 10px;

  /* 添加阴影 */
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
  height: 70px;
  }

  /*弹窗表单、*/

  .fomebox3{
    width: 84vw;
    background-color: #f7f7f7;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    gap: 10px;
    
    padding-bottom: 3vh;
   
  }
  .custom-title{
    width: 75vw;
    margin-top: 10px;
    color: #333333;
  }
  .pukisubmit-btn{
    width: 80px;
    padding: 8px;
    background: #000;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 15px;
    cursor: pointer;
    margin-top: 8px;
    font-weight: 500;
  }
  .submit-btn:disabled {
            background: #ccc;
            cursor: not-allowed;
        }

  .custom-form{
   
    border-radius: 5px;
    width: 75vw;
    height: 300px;
   
  }
  .custom-form .form-group {
    background: #FFFFFF;
    border-radius: 5px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    padding: 8px 8px;
    position: relative;

    margin-bottom: 10px;
    
}
.custom-form .form-group label {
    font-size: 12px;
    color: #333;
    margin-right: 50px;
    width: 40px;
    white-space: nowrap; /* 禁止换行 */
}
.form-group input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 12px;
    color: #333;
    background: transparent;
}
.form-group input::placeholder {
    color: #999;
}
 /* 添加底部投影效果 */
 .form-group::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 1px;
    background: rgba(0, 0, 0, 0.05);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.pukiuser-btn{
    width: 82vw;
    background: #000;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 17px;
    cursor: pointer;
    height: 50px;
    font-weight: 500;
}
/* 产品详情*/
.imagesite-container{
    margin-top: 4vh;
    width: 100vw;
    padding: 0;
}
.imagesite-container img{
    width: 100%;
    display: block; /* 让图片独占一行，去掉 inline-block 间距 */
    margin: 0; /* 确保没有外边距 */
    padding: 0; /* 确保没有内边距 */
    border: none; /* 确保没有边框 */
}
</style>
